<template>
    <Table :pagination="false" details :tableData="detailsData" :class="{'table__column_size' : changeStyleColumns}">
            <template v-slot:head>
                <vs-th sort-key="name" class="column__domain">{{i('global.Domains')}}</vs-th>
                <vs-th sort-key="leads_total" class="column__data">{{i('global.Leads')}}</vs-th>
                <vs-th sort-key="deposits_total" class="column__data">{{i('global.Deposits')}}</vs-th>
                <vs-th sort-key="conversion" class="column__data">%</vs-th>
            </template>

            <template v-slot:content="{content}">
                <vs-td class="cell__data">
                    <p>{{content.name}}</p>
                </vs-td>
                <vs-td class="cell__data">
                    <p>{{content.leads_total}}</p>
                </vs-td>
                <vs-td class="cell__data">
                    <p>{{content.deposits_total}}</p>
                </vs-td>
                <vs-td class="cell__data">
                    <p>{{Number(content.conversion).toFixed(2)}}</p>
                </vs-td>
            </template>

            <template v-slot:details="{details}">
                <DetailsDomains :detailsData="details.advertisers" :change-style-columns="changeStyleColumns"/>
            </template>
    </Table>
</template>

<script>
import i18n from '../../../i18n/i18n'
import DetailsDomains from './DetailsDomains'
import Table from '@/components/custom-table/Table'
import store from '@/store'

export default {
    props: {
        detailsData: {
            type: Array,
            default() {
                return []
            }
        },
        changeStyleColumns: {
            type: Boolean,
            default: false
        }
    },

    components: {
        DetailsDomains,
        Table
    },

    methods: {
        i(val) {
            return i18n.tc(val)
        }
    }
}
</script>
